import {defineMessages}      from "react-intl";

const STATES_TRANSLATIONS = defineMessages({
	// Canada
	'alberta': { id: "DATA.states.CA.AB", defaultMessage: "Alberta" },
	'prince_edward_island': { id: "DATA.states.CA.PE", defaultMessage: "Île-du-Prince-Édouard" },
	'quebec': { id: "DATA.states.CA.QC", defaultMessage: "Québec" },
	'ontario': { id: "DATA.states.CA.ON", defaultMessage: "Ontario" },
	'newfoundland_and_labrador': { id: "DATA.states.CA.NL", defaultMessage: "Terre-Neuve-et-Labrador" },
	'british_columbia': { id: "DATA.states.CA.BC", defaultMessage: "Colombie-Britannique" },
	'manitoba': { id: "DATA.states.CA.MB", defaultMessage: "Manitoba" },
	'new_brunswick': { id: "DATA.states.CA.NB", defaultMessage: "Nouveau-Brunswick" },
	'northwest_territories': { id: "DATA.states.CA.NT", defaultMessage: "Territoires du Nord-Ouest" },
	'nova_scotia': { id: "DATA.states.CA.NS", defaultMessage: "Nouvelle-Écosse" },
	'nunavut': { id: "DATA.states.CA.NU", defaultMessage: "Nunavut" },
	'saskatchewan': { id: "DATA.states.CA.SK", defaultMessage: "Saskatchewan" },
	'yukon': { id: "DATA.states.CA.YT", defaultMessage: "Yukon" },

	// United States
	'alabama': { id: "DATA.states.US.AL", defaultMessage: "Alabama" },
	'alaska': { id: "DATA.states.US.AK", defaultMessage: "Alaska" },
	'arizona': { id: "DATA.states.US.AZ", defaultMessage: "Arizona" },
	'arkansas': { id: "DATA.states.US.AR", defaultMessage: "Arkansas" },
	'california': { id: "DATA.states.US.CA", defaultMessage: "Californie" },
	'colorado': { id: "DATA.states.US.CO", defaultMessage: "Colorado" },
	'connecticut': { id: "DATA.states.US.CT", defaultMessage: "Connecticut" },
	'delaware': { id: "DATA.states.US.DE", defaultMessage: "Delaware" },
	'florida': { id: "DATA.states.US.FL", defaultMessage: "Floride" },
	'georgia': { id: "DATA.states.US.GA", defaultMessage: "Géorgie" },
	'hawaii': { id: "DATA.states.US.HI", defaultMessage: "Hawaï" },
	'idaho': { id: "DATA.states.US.ID", defaultMessage: "Idaho" },
	'illinois': { id: "DATA.states.US.IL", defaultMessage: "Illinois" },
	'indiana': { id: "DATA.states.US.IN", defaultMessage: "Indiana" },
	'iowa': { id: "DATA.states.US.IA", defaultMessage: "Iowa" },
	'kansas': { id: "DATA.states.US.KS", defaultMessage: "Kansas" },
	'kentucky': { id: "DATA.states.US.KY", defaultMessage: "Kentucky" },
	'louisiana': { id: "DATA.states.US.LA", defaultMessage: "Louisiane" },
	'maine': { id: "DATA.states.US.ME", defaultMessage: "Maine" },
	'maryland': { id: "DATA.states.US.MD", defaultMessage: "Maryland" },
	'massachusetts': { id: "DATA.states.US.MA", defaultMessage: "Massachusetts" },
	'michigan': { id: "DATA.states.US.MI", defaultMessage: "Michigan" },
	'minnesota': { id: "DATA.states.US.MN", defaultMessage: "Minnesota" },
	'mississippi': { id: "DATA.states.US.MS", defaultMessage: "Mississippi" },
	'missouri': { id: "DATA.states.US.MO", defaultMessage: "Missouri" },
	'montana': { id: "DATA.states.US.MT", defaultMessage: "Montana" },
	'nebraska': { id: "DATA.states.US.NE", defaultMessage: "Nebraska" },
	'nevada': { id: "DATA.states.US.NV", defaultMessage: "Nevada" },
	'new_hampshire': { id: "DATA.states.US.NH", defaultMessage: "New Hampshire" },
	'new_jersey': { id: "DATA.states.US.NJ", defaultMessage: "New Jersey" },
	'new_mexico': { id: "DATA.states.US.NM", defaultMessage: "Nouveau-Mexique" },
	'new_york': { id: "DATA.states.US.NY", defaultMessage: "New York" },
	'north_carolina': { id: "DATA.states.US.NC", defaultMessage: "Caroline du Nord" },
	'north_dakota': { id: "DATA.states.US.ND", defaultMessage: "Dakota du Nord" },
	'ohio': { id: "DATA.states.US.OH", defaultMessage: "Ohio" },
	'oklahoma': { id: "DATA.states.US.OK", defaultMessage: "Oklahoma" },
	'oregon': { id: "DATA.states.US.OR", defaultMessage: "Oregon" },
	'pennsylvania': { id: "DATA.states.US.PA", defaultMessage: "Pennsylvanie" },
	'rhode_island': { id: "DATA.states.US.RI", defaultMessage: "Rhode Island" },
	'south_carolina': { id: "DATA.states.US.SC", defaultMessage: "Caroline du Sud" },
	'south_dakota': { id: "DATA.states.US.SD", defaultMessage: "Dakota du Sud" },
	'tennessee': { id: "DATA.states.US.TN", defaultMessage: "Tennessee" },
	'texas': { id: "DATA.states.US.TX", defaultMessage: "Texas" },
	'utah': { id: "DATA.states.US.UT", defaultMessage: "Utah" },
	'vermont': { id: "DATA.states.US.VT", defaultMessage: "Vermont" },
	'virginia': { id: "DATA.states.US.VA", defaultMessage: "Virginie" },
	'washington': { id: "DATA.states.US.WA", defaultMessage: "Washington" },
	'west_virginia': { id: "DATA.states.US.WV", defaultMessage: "Virginie-Occidentale" },
	'wisconsin': { id: "DATA.states.US.WI", defaultMessage: "Wisconsin" },
	'wyoming': { id: "DATA.states.US.WY", defaultMessage: "Wyoming" },
	'district_of_columbia': { id: "DATA.states.US.DC", defaultMessage: "District de Columbia" },
	'puerto_rico': { id: "DATA.states.US.PR", defaultMessage: "Porto Rico" },
	'u_s_virgin_islands': { id: "DATA.states.US.VI", defaultMessage: "Îles Vierges des États-Unis" }
});

export default STATES_TRANSLATIONS;
